import React from 'react';
import { FaStar } from 'react-icons/fa';

const Testimonials: React.FC = () => {
  const testimonials = [
    {
      name: 'Sophie Martin',
      position: 'CEO, TechStart',
      image: 'https://randomuser.me/api/portraits/women/32.jpg',
      content: 'Grâce à Growlyy, nous avons pu augmenter notre nombre de rendez-vous commerciaux de 40% en seulement deux mois. La qualité des leads est exceptionnelle et notre taux de conversion a significativement augmenté.',
      stars: 5
    },
    {
      name: 'Thomas Dubois',
      position: 'Directeur Commercial, CreativeMinds',
      image: 'https://randomuser.me/api/portraits/men/46.jpg',
      content: 'Leur approche multi-canal est vraiment efficace. Nous avons essayé plusieurs agences de prospection avant, mais Growlyy est la seule qui nous a fourni des rendez-vous réellement qualifiés avec des décideurs.',
      stars: 5
    },
    {
      name: 'Émilie Rousseau',
      position: 'Directrice Marketing, InnoGroup',
      image: 'https://randomuser.me/api/portraits/women/65.jpg',
      content: 'Ce qui m\'a impressionné, c\'est la personnalisation des messages. Ils prennent vraiment le temps de comprendre notre offre et notre cible. Les prospects nous disent souvent qu\'ils ont apprécié l\'approche personnalisée.',
      stars: 4
    }
  ];

  const renderStars = (count: number) => {
    return Array(count).fill(0).map((_, i) => (
      <FaStar key={i} className="text-growlyy-secondary" />
    ));
  };

  return (
    <section id="temoignages" className="py-20 bg-growlyy-gray-light">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-growlyy-primary mb-4">Ce que nos clients disent</h2>
          <p className="text-xl text-growlyy-gray-dark max-w-2xl mx-auto">
            Découvrez comment notre service de prospection aide les entreprises à développer leur activité.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-white p-8 rounded-lg shadow-md hover:shadow-xl transition duration-300">
              <div className="flex items-center mb-6">
                <img 
                  src={testimonial.image} 
                  alt={testimonial.name} 
                  className="w-16 h-16 rounded-full mr-4 object-cover"
                />
                <div>
                  <h3 className="text-lg font-semibold text-growlyy-primary">{testimonial.name}</h3>
                  <p className="text-growlyy-gray-dark">{testimonial.position}</p>
                  <div className="flex mt-1">
                    {renderStars(testimonial.stars)}
                  </div>
                </div>
              </div>
              <p className="text-growlyy-gray-dark italic">"{testimonial.content}"</p>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <a href="https://zcal.co/adriengeen/15min" target="_blank" rel="noopener noreferrer" className="btn-primary btn-large btn-bounce">
            Réserver une démo
          </a>
        </div>
      </div>
    </section>
  );
};

export default Testimonials; 